import { connect } from 'react-redux';

import UserDropdown from './UserDropdown';
import { removeInactiveUsers } from '../../helpers/UserUtils';


const mapStateToProps = (state) => {
  return ({
    users: removeInactiveUsers(state.users),
    identityId: state.identity.id
  })
};

export default connect(mapStateToProps)(UserDropdown);
